import StudentDashboard from '@/components/Student/StudentDashboard'

const StudentDashboardScreen = () => {
  return <StudentDashboard />
}

export default StudentDashboardScreen
